import { makeTranslationHelpers } from '@/hooks/useTranslation';

const { useTranslation: useDividendTranslation } = makeTranslationHelpers(
  'page.companyReport.dividend'
);

export { useDividendTranslation };
